export const ProductCondition = {
  properties: {
    Operand: {
      'bulk-upload-header': 'Product Condition 1',
    },
    Attribute: {
      'bulk-upload-header': 'Product Value 1',
    },
  },
};
